import { FC, useEffect } from 'react';
import { Helmet } from "react-helmet";

import { AppTester } from "../../../supporting";
import { getIconSet } from './getIconSet';
import { useRouteMatch } from "react-router-dom";
import useMetaImage from 'shared/components/AlteredHelmet/useMetaImage';
import useMetaDescription from 'shared/components/AlteredHelmet/useMetaDescription';
import useCanonical from './useCanonical';
import useAppTester from 'shared/MobileMenu/hooks/useAppTester';
import { LinkTo } from 'shared/constants/linkTo';
import useIsAdminPage from 'shared/hooks/useIsAdminPage';

const AlteredHelmet: FC = () => {
  const {
    isGeoMain,
    isMediiia,
    isLectureMediiia,
    isFtbl,
  } = useAppTester();
  const isNoIndexPage = useIsAdminPage();

  const isMediiiaResidentsPage = !!useRouteMatch([LinkTo.residents, LinkTo.specialProjects, LinkTo.partners]) && (isMediiia || isLectureMediiia)

  const metaImage = useMetaImage();
  const metaDescription = useMetaDescription();
  const canonicalUrl = useCanonical();

  const noIndex = isGeoMain || isNoIndexPage || isFtbl;

  return (
    <Helmet>
      {metaDescription}
      {metaImage}
      {noIndex && <meta name="robots" content="noindex" />}
      {/* {canonicalUrl && <link rel="canonical" href={canonicalUrl} />} */}

      {isMediiiaResidentsPage && [
        <meta name="robots" content="index,follow" />,
        <meta property="og:type" content="website" />,
        <meta property="og:url" content={`${window.location.pathname}/residents`} />,
        <meta property="og:locale" content="ru_RU" />
      ]}

    </Helmet>
  )
}

export default AlteredHelmet;import { FC, useEffect } from 'react';
import { Helmet } from "react-helmet";

import { AppTester } from "../../../supporting";
import { getIconSet } from './getIconSet';
import { useRouteMatch } from "react-router-dom";
import useMetaImage from 'shared/components/AlteredHelmet/useMetaImage';
import useMetaDescription from 'shared/components/AlteredHelmet/useMetaDescription';
import useCanonical from './useCanonical';
import useAppTester from 'shared/MobileMenu/hooks/useAppTester';
import { LinkTo } from 'shared/constants/linkTo';
import useIsAdminPage from 'shared/hooks/useIsAdminPage';

const AlteredHelmet: FC = () => {
  const {
    isGeoMain,
    isMediiia,
    isLectureMediiia,
    isFtbl,
  } = useAppTester();
  const isNoIndexPage = useIsAdminPage();

  const isMediiiaResidentsPage = !!useRouteMatch([LinkTo.residents, LinkTo.specialProjects, LinkTo.partners]) && (isMediiia || isLectureMediiia)

  const metaImage = useMetaImage();
  const metaDescription = useMetaDescription();
  const canonicalUrl = useCanonical();

  const noIndex = isGeoMain || isNoIndexPage || isFtbl;

  return (
    <Helmet>
      {metaDescription}
      {metaImage}
      {noIndex && <meta name="robots" content="noindex" />}
      {/* {canonicalUrl && <link rel="canonical" href={canonicalUrl} />} */}

      {isMediiiaResidentsPage && [
        <meta name="robots" content="index,follow" />,
        <meta property="og:type" content="website" />,
        <meta property="og:url" content={`${window.location.pathname}/residents`} />,
        <meta property="og:locale" content="ru_RU" />
      ]}

    </Helmet>
  )
}

export default AlteredHelmet;